<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">Product Code Search</h2>
                </div>

                <div class="layout__padding-clear layout__width-70">
                    <ProductsSearch v-bind:searchParams="searchParams" v-bind:products="products"
                                    v-bind:loading="loading"></ProductsSearch>
                </div>
                <div>
                    <el-table :data="products.slice(this.start-1, this.end)" width="100%"
                              v-on:row-click="viewProduct"
                              v-loading.fullscreen.lock="loading">
                        <el-table-column prop="productRef" label="Order Code" width="200">
                        </el-table-column>
                        <el-table-column prop="priceCode" label="Price Code" width="200">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="100">
                        </el-table-column>
                        <el-table-column prop="type" label="Type" width="150">
                        </el-table-column>
                        <el-table-column prop="name" label="Name" width="400">
                        </el-table-column>
                        <el-table-column prop="press" label="Press" width="200">
                        </el-table-column>
                        <el-table-column prop="style" label="Style" width="120">
                        </el-table-column>
                        <el-table-column prop="isoSize" label="ISO Sizes" width="100">
                        </el-table-column>
                        <el-table-column prop="paperWeight" label="Stock" width="100">
                        </el-table-column>
                        <el-table-column prop="paperType" label="Paper" width="100">
                        </el-table-column>
                        <el-table-column prop="finishing" label="Finishing" width="150">
                        </el-table-column>
                    </el-table>
                </div>

                <Pagination v-bind:orders="products" v-bind:start="start" v-bind:end="end"
                            v-bind:pagination="pagination"></Pagination>

            </div>
        </div>
    </div>

</template>

<script>
    import ProductsSearch from '../../components/search/ProductsSearch.vue';
    import Pagination from "../../components/Pagination";

    export default {
        name: "products",
        mixins: [],
        components: {
            ProductsSearch,
            Pagination
        },
        data() {
            return {
                products: [],
                start: 1,
                end: 20,
                pagination: 20,
                searchParams: {
                    freetext: '',
                    status: 'ARCHIVE'
                },
                loading: false
            }
        },
        created() {
            // todo this needs to make the call - the same defaults as
            this.isUserAuthorised();
        },
        methods: {
            viewProduct(product) {
                this.$router.push({
                    name: '/billing/products/details',
                    params: {
                        product: product
                    },
                    query: {
                        code: product.code,
                    }
                })
            },
            // createNewProduct() {
            //     this.$router.push({
            //         name: '/billing/products/create',
            //     })
            // }
        }
    };
</script>